import { CalendarOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import CIQDatePicker from "components/custom-date-picker";
import type { Dayjs } from "dayjs";
import { useState, useImperativeHandle, forwardRef } from "react";

type Props = {
  value?: Dayjs | null;
  disabled?: boolean;
  onChange: (value: Dayjs | null, dateString: string | null) => void;
  disabledDate?: (current: Dayjs) => boolean;
  renderExtraFooter?: (mode: any) => React.ReactNode;
  title?: string;
};

const SetActualDatePicker = forwardRef((props: Props, ref: any) => {
  const {
    value,
    disabled = false,
    onChange,
    disabledDate,
    renderExtraFooter,
    title
  } = props;

  const [openDatePicker, setOpenDatePicker] = useState(false);
  useImperativeHandle(ref, () => ({
    close() {
      setOpenDatePicker(false);
    }
  }));

  return (
    <div>
      <CIQDatePicker
        className="h-0 w-0 p-0 m-0 border-0 border-none bg-white ciq-date-picker "
        popupClassName="pt-3"
        allowClear={false}
        open={openDatePicker}
        onOpenChange={() => setOpenDatePicker(false)}
        value={value}
        onChange={onChange}
        disabledDate={disabledDate}
        renderExtraFooter={renderExtraFooter}
      />
      <Tooltip title={title}>
        <Button
          disabled={disabled}
          className="border p-1 h-fit text-opacity-80 bg-transparent border-ciq-gray-300 rounded text-xs"
          onClick={() => {
            setOpenDatePicker(true);
          }}
          data-testid="setactualdatebutton-button"
        >
          Set Actual Date <CalendarOutlined />
        </Button>
      </Tooltip>
    </div>
  );
});
SetActualDatePicker.displayName = "SetActualDatePicker";
export default SetActualDatePicker;
